<template>
    <footer class="bg-secondary">
        <b-container class="py-3">
            <b-row
                align-v="center"
                align-h="between"
                class="small"
            >
                <b-col>
                    <b-nav class="flex-column flex-sm-row">
                        <b-nav-item :to="{name: `privacy${routePrefix}`}">
                            {{ $t('common.footer.privacy') }}
                        </b-nav-item>

                        <b-nav-item :to="{name: `disclaimer${routePrefix}`}">
                            {{ $t('common.footer.disclaimer') }}
                        </b-nav-item>
                    </b-nav>
                </b-col>

                <b-col cols="auto">
                    {{ $t('common.footer.copyright') }}
                </b-col>
            </b-row>
        </b-container>
    </footer>
</template>

<script>
export default {
    name: 'OwFooter',
    data() {
        return {
            routePrefix: undefined,
        };
    },
    watch: {
        $route: {
            handler: function(val) {
                this.routePrefix = this.$route.name.endsWith('Cancer') ? 'Cancer' : '';
            },
            immediate: true,
        },
    },
};
</script>

<style lang="scss">
footer {
    .nav-item .nav-link {
        padding-top: .2rem;
        padding-bottom: .2rem;
        padding-left: 0;
    }
}
</style>
